import React from 'react'
import PropTypes from 'prop-types'
import { View } from '@react-pdf/renderer'

import { hexToRgbA } from '@util/stringUtil'
import colors from '@settings/styleSettings'
import Text from './Text'

// Create Document Component
export const Status = ({
  textColor, text, icon, style, textStyle
}) => {
  return (
    <View
      style={[
        {
          backgroundColor: hexToRgbA(textColor, '0.16'),
          borderRadius: '50%',
          padding: '4 8',
          height: 24,
          minWidth: 24,
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: 10,
        },
        style,
      ]}
    >
      {icon && icon(textColor)}
      <Text
        style={[
          {
            marginLeft: icon ? 10 : 0,
            color: textColor,
            fontFamily: 'Inter-Bold',
          },
          textStyle,
        ]}
      >
        {text}
      </Text>
    </View>
  )
}

Status.propTypes = {
  text: PropTypes.string.isRequired,
  textColor: PropTypes.string,
  icon: PropTypes.func,
  textStyle: PropTypes.shape({}),
  style: PropTypes.shape({}),
}

Status.defaultProps = {
  icon: null,
  textStyle: {},
  textColor: colors.titleStrongBlack,
  style: null,
}
